import { createAction, props } from '@ngrx/store';
import { CaptchaResponse } from 'src/app/models/main-page/captcha-response.model';
import { PickupDateHoursPeriodResponse } from 'src/app/models/pickup-date-hours-period/pickup-date-hours-period-response.model';
import { PickupResponse } from 'src/app/models/pickup/pickup-response.model';
import { PreAuthRequest } from 'src/app/models/pre-auth/pre-auth-request.model';
import { PreAuthResponse } from 'src/app/models/pre-auth/pre-auth-response.model';

export const changePreAuthRequest = createAction(
  '[ApiData] Change preAuthRequest',
  props<{ preAuthRequest: PreAuthRequest | undefined }>()
);

export const changeCaptchaResponse = createAction(
  '[ApiData] Change captchaResponse',
  props<{ captchaResponse: CaptchaResponse | undefined }>()
);

export const changePreAuthResponse = createAction(
  '[ApiData] Change preAuthResponse',
  props<{ preAuthResponse: PreAuthResponse | undefined }>()
);

export const changePickupDateHoursPeriodResponse = createAction(
  '[ApiData] Change pickupDateHoursPeriodResponse',
  props<{
    pickupDateHoursPeriodResponse: PickupDateHoursPeriodResponse | undefined;
  }>()
);

export const changePickupResponse = createAction(
  '[ApiData] Change pickupResponse',
  props<{ pickupResponse: PickupResponse | undefined }>()
);
